var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-list-item',[_c('v-progress-linear',{attrs:{"value":_vm.arquivo.progress,"color":"green lighten-3","height":"20","striped":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var value = ref.value;
return [_vm._v(" "+_vm._s(_vm.arquivo.nome)+" - upload "),_c('v-spacer'),_c('strong',[_vm._v(_vm._s(Math.ceil(value))+"%")])]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }